import { reorderList } from '@carboncopyco/editor-utils';
import type { DraggableListProps } from '../../DraggableList';
import { DraggableList } from '../../DraggableList';
import { RuleListItem } from './RuleListItem';
import {
  RuleListProvider,
  type RuleListProviderProps,
} from './RuleListProvider';

export interface RuleItemConfig<T> {
  id: string;
  rule: T;
}

export interface RuleListProps<T> extends RuleListProviderProps {
  rules: RuleItemConfig<T>[];
  draggable?: DraggableListProps<T>['disabled'];
  renderItem: (rules: RuleItemConfig<T>, index: number) => React.ReactNode;
  onOrderChange?: (newOrder: {
    rules: RuleListProps<T>['rules'];
    destinationIndex: number;
  }) => void;
  withLeftBorder?: boolean;
}

export const RuleList = <T,>({
  openedRules,
  rules,
  draggable,
  renderItem,
  onOpenRule,
  onCloseRule,
  onOrderChange,
  withLeftBorder,
}: RuleListProps<T>) => (
  <RuleListProvider
    rules={rules}
    openedRules={openedRules}
    onOpenRule={onOpenRule}
    onCloseRule={onCloseRule}
  >
    <DraggableList
      withLeftBorder={withLeftBorder}
      items={rules.map((rule) => ({
        id: rule.id,
        item: rule,
      }))}
      renderItem={(rule, index) => renderItem(rule, index)}
      disabled={!draggable}
      onDragEnd={({ sourceIndex, destinationIndex }) => {
        const reorderedRules = reorderList(
          rules,
          sourceIndex,
          destinationIndex
        );
        onOrderChange?.({
          rules: reorderedRules,
          destinationIndex,
        });
      }}
    />
  </RuleListProvider>
);

RuleList.Item = RuleListItem;
